<section class="app-feature pb-100 mt-50">
    <div class="container">
        <div class="row">
            <div class="col-lg-4">
                <div class="app-feature-content">
                    <div class="section-title">
                        <div class="section-heading-tag">
                            <span class="single-heading-tag">About</span>
                        </div>
                        <div class="section-title-description">
                            <p>Polypharm Solutions is a tool changing the way we choose medications. Using
                                advanced algorithms, our software analyzes how medications interact with each other,
                                and other relevant factors to identify potential side effects. This allows
                                doctors to make informed decisions and prevent adverse
                                reactions in their patients. Polypharm Solutions is paving the way for personalized
                                medication selection – try it for yourself today!</p>
                        </div>
                        <div class="section-button-wrapper">
                            <a routerLink="/about" class="filled-btn">
                                Learn More <i class="fas fa-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-8">
                <div class="app-features-list">
                    <!-- Data -->
                    <div class="single-service-box wow fadeInDown" [ngClass]="item.active ? 'active':''" data-wow-delay="100ms" data-wow-duration="2500ms" *ngFor="let item of feature | slice:0:2">
                        <div class="service-box-title">
                            <h3>{{item.title}}</h3>
                        </div>
                        <div class="service-thumbnail">
                            <img [src]="item.image" [alt]="item.title">
                        </div>
                        <div class="service-box-content">
                            <div class="section-title-description">
                                <p>{{item.text}}</p>
                            </div>
                            <div class="service-box-btn">
                                <a routerLink="/apps"><i class="fas fa-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                    <!-- Data -->
                </div>
            </div>
        </div> <!-- /.row -->
    </div> <!-- /.container -->
</section>
